import React from 'react';

import { OrdCreate, OrdEdit } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { CallRecordingConfsForm } from './CallRecordingConfsForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { CallRecordingConf } from '@ragu-components/ord-types';

const CallRecordingConfsList = React.lazy(async () => import('./CallRecordingConfsList'));

export const callRecordingConfsResource: OrdResourceProps = {
  key: Resources.call_recording_confs,
  name: Resources.call_recording_confs,
  list: <CallRecordingConfsList />,
  edit: (
    <OrdEdit>
      <CallRecordingConfsForm />
    </OrdEdit>
  ),
  create: (
    <OrdCreate>
      <CallRecordingConfsForm />
    </OrdCreate>
  ),
  options: {},
  recordRepresentation: (record: CallRecordingConf): string => record.name,
};
